export default __webpack_public_path__ + "static/media/img_home_card.45d2589f.png";